/* eslint-disable no-unused-vars */
import Layout from 'components/common/Layout';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLogin } from 'views/AdminLogin';
import { useDispatch, useSelector } from 'react-redux';
import ViewsLayout from 'views/ViewsLayout';
import { UserLogin1 } from 'views/Login.user';
import { Suspense, useEffect, useLayoutEffect, useState, useMemo, useRef } from 'react';
import { Loader } from 'components';
import { authActions, ssoLogin } from 'store/auth/auth';
import { EmailValidatePage } from 'views';
import {
  UserLogin,
  UserSignup,
  ForgotPassword,
  ResetPassword,
  WelcomePage,
} from 'views/loginPages';
import {
  getIsLocalHost,
  redirectToOldPlatformLoginUrl,
  isPrefixInUrl,
  redirectToLoginPage,
} from 'utils';
import { LocalLogin, LoginPublisherList } from 'views/loginPages';
import { authAPI } from 'services/newPlatformAuth.service';
import { authGoogleClientId, authGoogleKey } from 'constants';
import { isPublisherRole } from 'store/selectors';

import ButtonsPage from 'components/common/button/ButtonsPage';

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`;`).filter(Boolean);
  let currentCookie;
  parts.forEach((part) => {
    if (part.includes(name)) {
      const value = part.split('=')[1];
      if (value) {
        currentCookie = value;
      }
    }
  });
  //return '1737796580581';
  return currentCookie;
}

const isSomethingIsMissing = (...args) => args.some((arg) => !arg);

function App() {
  const [switchUserAction, switchUserResult] = authAPI.useSwitchUserMutation();

  const [isLoading, setIsLoading] = useState(true);

  const accessToken = useSelector((state) => state.auth.accessToken);
  const refreshToken = useSelector((state) => state.auth.refreshToken);
  const pb_number = useSelector((state) => state.auth.pb_number);
  const authType = useSelector((state) => state.auth.authType);

  const isUserLogin = useSelector((state) => state.auth.isUserLogin);

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const isSsoLoading = useSelector((state) => state.auth.isSsoLoading);
  const isPublisher = useSelector(isPublisherRole);
  const dispatch = useDispatch();

  const fetchFlag = useRef(false);

  const FALLBACK_ROUTE = isPublisher ? '/manage_apps' : '/Discovery/Manage';

  const showLoader = useMemo(() => {
    if (fetchFlag.current) {
      return true;
    }
    if (switchUserResult.isLoading) {
      return true;
    }
    return false;
  }, [accessToken, refreshToken, pb_number, switchUserResult.isLoading]);

  useLayoutEffect(() => {
    const isLoginCookie = getCookie(authGoogleKey);
    if (isPrefixInUrl() && !isLoginCookie && !showLoader) {
      dispatch(authActions.setIsLoggedInToFalse());
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await switchUserAction();
        //console.log('switchUserAction', res.data);
        if (res.data) {
          const { access_token, refresh_token, pb_email, pb_username, pb_number, pb_roles } =
            res.data;
          dispatch(
            authActions.setAuthData({
              accessToken: access_token,
              refreshToken: refresh_token,
              pb_email,
              pb_username,
              isLoggedIn: true,
              pb_number,
              pb_roles,
            }),
          );
          fetchFlag.current = false;
        }
      } catch (error) {
        console.error('Error during switchUserAction:', error);
        fetchFlag.current = false;
      }
    };
    if (
      isPrefixInUrl() &&
      isSomethingIsMissing(accessToken, refreshToken, pb_number) &&
      !fetchFlag.current
    ) {
      console.log('fetch switchUserAction');
      fetchFlag.current = true;
      console.log('here1');
      fetchData();
    }
    if (isPrefixInUrl() && !isSomethingIsMissing(accessToken, refreshToken, pb_number)) {
      dispatch(authActions.setIsLoggedInToTrue());
    }
  }, [accessToken, refreshToken, pb_number]);

  if (switchUserResult.isError) {
    redirectToLoginPage();
    return <div>switchUser error</div>;
  }

  if (showLoader) {
    return <Loader.Global delay={0} />;
  }

  return (
    <div className='App'>
      <Layout
        main={
          <Routes>
            <Route
              path='/'
              element={
                window.SHOW_ADMIN_LOGIN_ON_ROOT ? (
                  <Navigate to='/adminLogin' replace />
                ) : (
                  <UserLogin />
                )
              }
            />
            {isLoggedIn && (
              <Route path='/userLogin' element={<Navigate to={FALLBACK_ROUTE} replace />} />
            )}
            {isLoggedIn && (
              <Route
                path='/*'
                element={
                  <Suspense fallback={<Loader.Global delay={1} />}>
                    <ViewsLayout />
                  </Suspense>
                }
              />
            )}
            {!isLoggedIn && (
              <>
                <Route path='/adminLogin' element={<AdminLogin />} />
                <Route path='/userLogin' element={<UserLogin />} />
                <Route path='/signup' element={<UserSignup />} />
                <Route path='/signup-success' element={<WelcomePage />} />
                <Route path='/reset' element={<ResetPassword />} />
                <Route path='/forgot-password' element={<ForgotPassword />} />
                <Route path='/email-validate' element={<EmailValidatePage />} />
                <Route path='/account/login' element={<UserLogin1 />} />
              </>
            )}

            {/* <Route
                path='*'
                element={
                  <main style={{ padding: '1rem' }}>
                    <p>There&apos;s nothing here!</p>
                  </main>
                }
              /> */}
            {/* Design System text page */}
            {/* <Route path='/buttons' element={<ButtonsPage />} /> */}
          </Routes>
        }
      />
    </div>
  );
}

export default App;
